<template>
  <el-dialog title="新增访客"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-card shadow="none">
      <el-col :span="24">
        <el-form :model="checkInData"
                 :rules="checkInRules"
                 ref="checkInForm"
                 label-width="135px"
                 class="checkin-form">

          <el-form-item label="访客卡:"
                        prop="med_value">
            <el-input v-model.trim="checkInData.med_value"
                      placeholder="访客卡号">
              <el-button slot="append"
                         @click="readIC()"
                         type="primary">读IC卡</el-button>
            </el-input>
            <span v-if="countDownIC">请刷访客卡{{timerIC}}</span>
          </el-form-item>

          <el-form-item label="证件号码:"
                        prop="vist_id_no">
            <el-input v-model.trim="checkInData.vist_id_no"
                      placeholder="证件号码">
              <el-button slot="append"
                         @click="readID()"
                         type="primary">读身份证</el-button>
            </el-input>
            <span v-if="countDownID">请刷身份证{{timerID}}</span>
            <img :src="checkInData.vist_photo" />
          </el-form-item>

          <el-form-item label="访客姓名:"
                        prop="vist_name">
            <el-input v-model.trim="checkInData.vist_name"
                      placeholder="访客姓名">
            </el-input>
          </el-form-item>

          <el-form-item label="访客性别:"
                        prop="vist_sex">
            <el-radio-group v-model="checkInData.vist_sex">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="访客出生日期:"
                        prop="vist_birthday">
            <el-tag>{{checkInData.vist_birthday}}</el-tag>
          </el-form-item>

          <el-form-item label="访客地址:"
                        prop="vist_address">
            <el-input v-model.trim="checkInData.vist_address"
                      placeholder="访客地址">
            </el-input>
          </el-form-item>

          <el-form-item label="访客联系方式:"
                        prop="vist_contex">
            <el-input v-model.trim="checkInData.vist_contex"
                      placeholder="访客联系方式">
            </el-input>
          </el-form-item>

          <el-form-item label="访客车牌号码:"
                        prop="vist_car_no">
            <el-input v-model.trim="checkInData.vist_car_no"
                      placeholder="车牌号码">
            </el-input>
          </el-form-item>

          <el-form-item label="同行人数:"
                        prop="vist_people_count">
            <el-input v-model.trim="checkInData.vist_people_count"
                      placeholder="同行人数">
            </el-input>
          </el-form-item>

          <el-form-item label="来访事由:"
                        prop="vist_cause">
            <el-input v-model.trim="checkInData.vist_cause"
                      placeholder="来访事由">
            </el-input>
          </el-form-item>

          <el-form-item label="携带物品:"
                        prop="vist_goods">
            <el-input v-model.trim="checkInData.vist_goods"
                      placeholder="携带物品">
            </el-input>
          </el-form-item>

          <el-form-item label="被访人部门:"
                        prop="inter_dep_id">
            <el-select v-model="checkInData.inter_dep_id"
                       ref="refDepSel"
                       placeholder="请选择被访人所在部门"
                       @change="depSelChange()">
              <el-option v-for="item in depList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="被访人:"
                        prop="inter_id">
            <el-select v-model="checkInData.inter_id"
                       placeholder="选择被访人"
                       @change="personSelChange()">
              <el-option v-for="item in personList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="被访人联系方式:">
            <el-tag>{{checkInData.inter_contex}}</el-tag>
          </el-form-item>

          <!--
          <el-form-item label="被访人姓名:"
                        prop="inter_id">
            <el-input v-model.trim="checkInData.inter_id"
                      placeholder="被访人姓名">
            </el-input>
          </el-form-item>
          
          <el-form-item label="被访人电话:"
                        prop="inter_contex">
            <el-input v-model.trim="checkInData.inter_contex"
                      placeholder="被访人电话">
            </el-input>
          </el-form-item>
          -->

          <el-form-item label="访问区域（楼层）:"
                        prop="inter_area_id">
            <el-select v-model="checkInData.inter_area_id"
                       ref="refAreaSel"
                       placeholder="请选择访问区域"
                       @change="areaSelChange()">
              <el-option v-for="item in areaList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="访问房间:"
                        prop="inter_lock_id">
            <el-select v-model="checkInData.inter_lock_id"
                       ref="refLockSel"
                       placeholder="请选择访问房间">
              <el-option v-for="item in lockList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="备注:"
                        prop="remark">
            <el-input v-model.trim="checkInData.remark"
                      placeholder="备注">
            </el-input>
          </el-form-item>

        </el-form>
      </el-col>
    </el-card>

    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary"
                 @click="handleConfirm('checkInForm')">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
import mediumApi from '@/common/medium'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: String
    },
    areaList: {},
    depList: {}
  },
  data() {
    return {
      countDownIC: false,
      countDownID: false,
      timerIC: 45,
      timerID: 45,
      timeObj: null,
      medType: '',
      randomNum: '',
      showModal: this.isShow,
      lockList: [],
      personList: [],
      checkInData: {
        med_value: '',
        vist_id_no: '',
        vist_name: '',
        vist_sex: '',
        vist_birthday: '',
        vist_address: '',
        vist_contex: '',
        vist_car_no: '',
        vist_people_count: '',
        vist_cause: '',
        vist_goods: '',
        vist_photo: '',
        inter_dep_id: '',
        inter_dep_name: '',
        inter_id: '',
        inter_name: '',
        inter_sex: '',
        inter_contex: '',
        inter_area_id: '',
        inter_area_name: '',
        inter_lock_id: '',
        inter_lock_name: '',
        remark: ''
      },
      checkInRules: {
        med_value: [{ required: true, message: '请输读卡或者输入卡号' }],
        vist_id_no: [{ required: true, message: '请读取证件或输入证件号码' }],
        vist_name: [{ required: true, message: '请读取证件或输入访客姓名' }],
        vist_contex: [{ required: true, message: '请输入访客联系方式' }],
        vist_people_count: [{ required: true, message: '请输入来访人数' }],
        vist_cause: [{ required: true, message: '请输入来访事由' }],
        inter_dep_id: [{ required: true, message: '请选择被放人所属部门' }],
        inter_id: [{ required: true, message: '请选择被访人' }],
        inter_area_id: [{ required: true, message: '请选择访问区域' }]
      }
    }
  },
  created() {
    this.getInfo()
  },
  beforeDestroy() {
    if (this.randomNum) {
      this.cancelInput()
    }
  },
  methods: {
    getInfo() {
      return 'girl'
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let tmp1 = this.$refs.refDepSel.selectedLabel
          let tmp2 = this.$refs.refAreaSel.selectedLabel
          this.checkInData.inter_dep_name = tmp1.replace(/• /g, '')
          this.checkInData.inter_area_name = tmp2.replace(/• /g, '')
          this.checkInData.inter_lock_name = this.$refs.refLockSel.selectedLabel

          fetch.visitorAdd({ ...this.checkInData }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.handleCancel('refresh')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel(val) {
      this.$emit('handleClose', val)
    },
    //区域选择联动设备筛选
    areaSelChange() {
      this.lockList = []
      this.checkInData.inter_lock_id = ''
      fetch
        .getLockList({
          perPage: 0,
          currentPage: 0,
          type: 'old',
          area_id: this.checkInData.inter_area_id
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.lockList = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },

    //部门选择联动人员筛选
    depSelChange() {
      this.personList = []
      this.checkInData.inter_id = ''
      fetch
        .getInterList({ perPage: 0, currentPage: 0, inter_dep_id: this.checkInData.inter_dep_id })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.personList = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },

    //人员选择 提取人员信息
    personSelChange() {
      for (var item in this.personList) {
        if (this.personList[item].id === this.checkInData.inter_id) {
          this.checkInData.inter_name = this.personList[item].name
          this.checkInData.inter_sex = this.personList[item].sex
          this.checkInData.inter_contex = this.personList[item].contact_ctx
        }
      }
    },

    //读取ic卡号
    readIC() {
      // loading倒计时提醒
      this.medType = 'ic'
      this.countDownIC = true
      this.timeObj = setInterval(() => {
        if (this.timerIC > 0) {
          this.timerIC--
        }
        if (this.timerIC === 0) {
          this.countDownIC = false
          clearInterval(this.timeObj)
        }
      }, 1000)
      this.randomNum = this.getRandomNum()
      mediumApi
        .getMediumInfo(
          {
            medType: this.medType,
            medTag: this.randomNum
          },
          { timeout: 45000 }
        )
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              if (data.medType === 'ic' && data.medTag === this.randomNum) {
                this.randomNum = ''
                this.checkInData.med_value = data.medValue
                this.$message.success('读取成功')
              }
              this.countDownIC = false
              clearInterval(this.timeObj)
            },
            (err) => {
              this.countDownIC = false
              this.checkInData.med_value = ''
              clearInterval(this.timeObj)
              this.$message.error(err)
            }
          )
        })
    },

    //读取身份证
    readID() {
      // loading倒计时提醒
      this.medType = 'id'
      this.countDownID = true
      this.timeObj = setInterval(() => {
        if (this.timerID > 0) {
          this.timerID--
        }
        if (this.timerID === 0) {
          this.countDownID = false
          clearInterval(this.timeObj)
        }
      }, 1000)
      this.randomNum = this.getRandomNum()
      mediumApi
        .getMediumInfo(
          {
            medType: this.medType,
            medTag: this.randomNum
          },
          { timeout: 45000 }
        )
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              if (data.medType === 'id' && data.medTag === this.randomNum) {
                this.randomNum = ''
                var list = data.medValue.split('#')
                if (list.length < 8) {
                  this.countDownID = false
                  this.checkInData.vist_id_no = ''
                  this.checkInData.vist_photo = ''
                  clearInterval(this.timeObj)
                  this.$message.error('读取错误')
                } else {
                  this.checkInData.vist_id_no = list[0]
                  this.checkInData.vist_name = list[1]
                  this.checkInData.vist_sex = list[2]
                  this.checkInData.vist_birthday = list[4]
                  this.checkInData.vist_address = list[5]
                  this.checkInData.vist_photo = `data:image/bmp;base64,` + data.base64Img
                  // temp 除了身份证号还得获得其他信息
                  this.$message.success('读取成功')
                }
              }
              this.countDownID = false
              clearInterval(this.timeObj)
            },
            (err) => {
              this.countDownID = false
              this.checkInData.vist_id_no = ''
              clearInterval(this.timeObj)
              this.$message.error(err)
            }
          )
        })
    },

    // 取消录入
    cancelInput() {
      mediumApi
        .cancelMediumInfo({
          medType: this.medType,
          medTag: this.randomNum
        })
        .then((data) => {
          data.procData(
            data.res,
            () => {
              this.randomNum = ''
              clearInterval(this.timeObj)
            },
            (err) => {
              this.countDownIC = false
              this.countDownID = false
              clearInterval(this.timeObj)
              this.$message.error(err)
            }
          )
        })
    },

    getRandomNum() {
      let randomNum = new Date().getTime() + ''
      let tmpLen = randomNum.length
      let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let maxPos = $chars.length
      for (var i = 0; i < 32 - tmpLen; i++) {
        randomNum += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return randomNum
    }
  }
}
</script>

<style></style>
